function normalizeText(value) {
  return String(value ?? '').trim();
}

function normalizeOptionalNumber(value) {
  if (value === null || value === undefined || value === '') return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

export function normalizeUnionRosterMember(row = {}) {
  const memberOpenid = normalizeText(row.member_openid ?? row.memberOpenid);
  if (!memberOpenid) return null;

  return {
    id: normalizeText(row.id ?? row.roster_member_id ?? row.rosterMemberId),
    memberOpenid,
    nickname: normalizeText(row.nickname ?? row.member_nickname ?? row.memberNickname) || '닉네임 확인 불가',
    syncLevel: normalizeOptionalNumber(row.sync_level ?? row.syncLevel),
    commanderLevel: normalizeOptionalNumber(row.commander_level ?? row.commanderLevel),
    iconId: normalizeText(row.icon_id ?? row.iconId),
    avatarUrl: normalizeText(row.avatar_url ?? row.avatarUrl),
    active: row.active !== false,
    syncedAt: row.synced_at ?? row.syncedAt ?? null,
    siteMember: Boolean(row.site_member ?? row.siteMember),
    siteRole: normalizeText(row.site_role ?? row.siteRole),
    linkedUserId: normalizeText(row.linked_user_id ?? row.linkedUserId),
  };
}

export function normalizeUnionRosterDirectory(payload = {}) {
  const members = (Array.isArray(payload.members) ? payload.members : [])
    .map(normalizeUnionRosterMember)
    .filter(Boolean)
    .filter((member) => member.active)
    .sort((left, right) => left.nickname.localeCompare(right.nickname, 'ko-KR'));

  const siteMemberCount = members.filter((member) => member.siteMember).length;

  return {
    unionId: normalizeText(payload.union_id ?? payload.unionId),
    unionName: normalizeText(payload.union_name ?? payload.unionName),
    viewerRole: normalizeText(payload.viewer_role ?? payload.viewerRole),
    lastSyncedAt: payload.last_synced_at ?? payload.lastSyncedAt ?? null,
    members,
    activeCount: members.length,
    siteMemberCount,
    unlinkedCount: Math.max(0, members.length - siteMemberCount),
  };
}

export function formatRosterLevel(value) {
  return Number.isFinite(value) && value > 0 ? String(Math.trunc(value)) : '-';
}
